import { DEFAULT_SOL_PARTY_LIMIT_IDO } from '@/config';
export enum STRATEGY_ENUM {
  DCA,
  CUSTOM,
  SMART_LP,
  KOL,
}

export const STRATEGY_LIST = [
  {
    label: 'DCA Policy (VA)',
    desc: 'Buy with SOL',
    isValid: true,
    value: STRATEGY_ENUM.DCA,
  },
  {
    label: 'Custom',
    desc: 'Custom by user',
    isValid: true,
    value: STRATEGY_ENUM.CUSTOM,
  },
  {
    label: 'Smart LP farming',
    desc: '--',
    isValid: false,
    value: STRATEGY_ENUM.SMART_LP,
  },
  {
    label: 'KOL Signal',
    desc: 'Powered by Modestus',
    isValid: false,
    value: STRATEGY_ENUM.KOL,
  },
];

export const AGENT_PERSONALITY = [
  {
    label: '😊 Friendly',
    value: 'Friendly',
  },
  {
    label: '💼 Professional',
    value: 'Professional',
  },
  {
    label: '🤡 Humorous',
    value: 'Humorous',
  },
  {
    label: '🛟 Supportive',
    value: 'Supportive',
  },
  {
    label: '🥰 Empathetic',
    value: 'Empathetic',
  },
  {
    label: '🤓 Informative',
    value: 'Informative',
  },
  {
    label: '🤠 Adventurous',
    value: 'Adventurous',
  },
  {
    label: '⭐️ Custom',
    value: 'Custom',
  },
];

export const AGENT_STYLE = [
  {
    label: '👔 Formal',
    value: 'Formal',
  },
  {
    label: '🧢 Casual',
    value: 'Casual',
  },
  {
    label: '🔥 Enthusiastic',
    value: 'Enthusiastic',
  },
  {
    label: '🍃 Calm',
    value: 'Calm',
  },
  {
    label: '👀 Direct',
    value: 'Direct',
  },
  {
    label: '📝 Storytelling',
    value: 'Informative',
  },
  {
    label: '⭐️ Custom',
    value: 'Custom',
  },
];

export const FUND_EXPIRATION_LIST = [
  {
    label: '14 days',
    value: 14 * 86400,
  },
  {
    label: '1 month',
    value: 30 * 86400,
  },
  {
    label: '3 months',
    value: 90 * 86400,
  },
  {
    label: '6 months',
    value: 6 * 30 * 86400,
  },
];

export type STEP_TYPE = {
  title: string;
  id: number;
  value: string;
};

// export const TIME_TO_LAUNCH = 7 * 24 * 60 * 60 * 1000;
export const TIME_TO_LAUNCH = 1 * 24 * 60 * 60 * 1000;

export const STEP_TOKEN_CREATION: STEP_TYPE[] = [
  {
    title: 'Token Info',
    id: 1,
    value: 'tokenInfo',
  },
  {
    title: 'Token created on Upcoming',
    id: 2,
    value: 'upcoming',
  },
  {
    title: 'Setting token launch',
    id: 3,
    value: 'tokenInfo',
  },
];

export const FAKE_UPCOMING_TOKEN = {
  _id: '67bfdd5edf3372df5a977a60',
  creator: '60c72b2f5f1b2c6f88f1b2c9',
  proposalLink: 'https://agents.land/',
  name: 'PBShares',
  ticker: 'PBS',
  description: 'description',
  url: 'https://example.com',
  date: '2025-02-27T03:34:36.565Z',
  metadata: {
    name: 'PBShares',
    symbol: 'PBS',
    image:
      'https://ipfs.io/ipfs/QmRd2WmyxDSsSk7WD1XgmymEcEkL7syAMDiz4jKuTu7M2J',
    description:
      'PROTOCOLBANK is the AI Hedge Fund for the NewAge Nations DAO, a Multi-AI-Agent ecosystem. ',
    agentPersonality: 'Friendly',
    agentStyle: 'Formal',
    createdOn: 'https://agents.land',
    twitter: 'https://x.com/protocolbank',
    website: 'https://www.newagenations.exchange',
    telegram: 'https://t.me/protocolbankdao',
    discord: 'https://discord.com/invite/ybSYGvmKT5',
    agentId: 181823,
    agentClanId: '@NewAgeNations',
    agentAddress: 'FgZgb9nYbPhRaB2ayc3FDN7GstbWoUuf665voPNjjdyF',
    creatorAddress: '9bNUhuXd6WNw3VR59jcWNvinCwGuNRm6XZHbN7hyY9J8',
    createdAt: 1739757566250,
    tags: 'agent',
    mode: null,
    defaiMode: 2,
    isIdoLaunch: false,
    curveLimit: 700,
    whitelistRoundPeriod: 1,
    fundsExpiration: 14 * 86400,
    partyLimit: DEFAULT_SOL_PARTY_LIMIT_IDO,
  },
  isCancel: false,
  __v: 0,
};

export enum LaunchingMode {
  FAIR,
  TRUMP,
  IDO,
}

export const LaunchingModeList = [
  {
    label: 'Fair Mode',
    value: 1,
  },
  {
    label: 'IDO Mode',
    value: 2,
  },
];
